import { useState, useEffect } from 'react'

import { gql, useQuery } from '@apollo/client';
import { ONE_MINUTE } from './pollIntervals';


const PSNodeType = gql`
query($env: String!) {
    priceserver_nodes(where: {env: {_eq: $env}}, order_by: {node: asc}) {
    ps_node_type
    ps_node_id
    node
    market_id
    submarket_id
  }
}
`

const PSNodeTypeAll = gql`
query {
    priceserver_nodes(order_by: {node: asc}) {
    ps_node_type
    ps_node_id
    node
    market_id
    submarket_id
  }
  }  
`

export function psLabelColor(label) {
    if (label.startsWith("PR")) {
        return "#00873D"
    } else if (label.startsWith("HA")) {
        return "#23395d"
    } else if (label.startsWith("DR")) {
        return "#333333"
    }
    return "#CCCCCC"
}

export function psLabelName(label) {
    if (label.startsWith("PR")) {
        return "Primary"
    } else if (label.startsWith("HA")) {
        return "High Availability"
    } else if (label.startsWith("DR")) {
        return "Disaster Recovery"
    }
    return "Loopback"
}

export const usePSNodeType = (envName) => {

    const [lookupData, setLookupData] = useState({})

    const ps_node_type = useQuery(
        envName === "%" ? PSNodeTypeAll : PSNodeType,
        {
            variables: envName === "%" ?
                {} :
                { env: envName }
            , pollInterval: ONE_MINUTE
        }
    )

    if (!ps_node_type.loading && ps_node_type.error) console.log(ps_node_type.error)

    useEffect(() => {
        if (!ps_node_type.loading && ps_node_type.data) {
            // Special handling for any PS that are in -md- environments
            let priceserver_nodes = {}
            if (!ps_node_type.loading && ps_node_type.data && ps_node_type.data.priceserver_nodes) {
                ps_node_type.data.priceserver_nodes.forEach(n => {
                    if (!priceserver_nodes[n.node]) {
                        priceserver_nodes[n.node] = {
                            mode: n.ps_node_type + "(" + n.ps_node_id + ")",
                            mkts: []
                        }
                    }
                    // Stupid but market_id should be always > 0
                    if (n.market_id > 0 && n.submarket_id > 0) {
                        priceserver_nodes[n.node].mkts.push(n.market_id + '.' + n.submarket_id)
                    }
                })
            }

            if (Object.keys(priceserver_nodes).length > 0) {
                setLookupData(priceserver_nodes)
            }

        }
    }, [ps_node_type.data, ps_node_type.loading])

    return lookupData
}